export default function DollarIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.4}
        d="M12 1C5.934 1 1 5.934 1 12s4.934 11 11 11 11-4.934 11-11S18.066 1 12 1zm0 1.467c5.274 0 9.54 4.26 9.54 9.533A9.532 9.532 0 0112 21.54 9.527 9.527 0 012.467 12 9.522 9.522 0 0112 2.467zm-.01 3.67a.733.733 0 00-.72.743v.617c-1.184.222-2.198.984-2.198 2.306 0 .916.414 1.658.969 2.09.555.431 1.181.623 1.731.806.55.183 1.025.359 1.295.569.27.21.4.386.4.936 0 1.223-2.928 1.223-2.928 0a.735.735 0 10-1.467 0c0 1.32 1.014 2.085 2.198 2.308v.614a.734.734 0 101.466 0v-.614c1.184-.223 2.199-.987 2.199-2.308 0-.916-.415-1.658-.97-2.09-.555-.431-1.181-.624-1.732-.807-.55-.184-1.024-.357-1.294-.567-.27-.21-.4-.387-.4-.937 0-1.222 2.928-1.222 2.928 0a.734.734 0 101.468 0c0-1.32-1.016-2.081-2.199-2.305V6.88a.733.733 0 00-.746-.742z"
      />
    </svg>
  );
}
